/* eslint-disable indent */
/* eslint-disable no-console */
/* eslint-disable no-else-return */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from 'react';
import './my-projects.scss';
import { VeoliaIcon } from '@veolia.com/vds-react-components';
import { keyboard_arrow_right } from '../../shared/assets/images';

const Folder = ({ explorer, handleInsertNode, handleDeleteNode, handleRenameNode, handleMoveNode,
  setShowFiles, setFileName, isRoot, explorerData, isSave }) => {
  const [showInput, setShowInput] = useState({
    visible: false,
    isFolder: null,
  });
  const [expand, setExpand] = useState(false);
  const [isRenaming, setIsRenaming] = useState(false);
  const [openMenuId, setOpenMenuId] = useState(null); // Track which menu is open
  const [hoveredId, setHoveredId] = useState(null); // Track which item is hovered
  const menuRef = useRef(null);
  const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });
  const [clickedId, setClickedId] = useState(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpenMenuId(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleNewFolder = (e, isFolder) => {
    e.stopPropagation();
    setExpand(true);
    setShowInput({
      visible: true,
      isFolder,
    });
    setOpenMenuId(null); // Close menu after action
  };

  const onAddFolder = (e) => {
    if (e.type === 'keydown' && e.keyCode !== 13) {
      return;
    }
    if (e.target.value) {
      handleInsertNode(explorer.id, e.target.value, showInput.isFolder);
    }
    setShowInput({ ...showInput, visible: false });
  };

  const onRename = (e) => {
    if (e.type === 'keydown' && e.keyCode !== 13) {
      return;
    }
    if (e.target.value) {
      handleRenameNode(explorer.id, e.target.value);
    }
    setIsRenaming(false);
    setOpenMenuId(null); // Close menu after action
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    handleDeleteNode(explorer.id);
    setOpenMenuId(null); // Close menu after action
  };

  const handleRename = (e) => {
    e.stopPropagation();
    setIsRenaming(true);
    setOpenMenuId(null); // Close menu after action
  };

  const toggleExpand = (e) => {
    e.stopPropagation();
    setExpand(!expand);
    setClickedId(explorer.id);
  };

  const handleDragStart = (e, node) => {
    e.stopPropagation();
    e.dataTransfer.setData('nodeId', node.id);
  };

  const handleDrop = (e, targetNode) => {
    e.stopPropagation();
    const nodeId = e.dataTransfer.getData('nodeId');
    handleMoveNode(nodeId, targetNode.id);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const toggleMenu = (e, id) => {
    e.stopPropagation();
    const rect = e.currentTarget.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    const menuHeight = 87; // Approximate height of the menu, adjust as needed

    const top = (viewportHeight - rect.bottom < menuHeight && rect.top > menuHeight)
      ? (rect.top - menuHeight) - 87
      : (rect.bottom) - 87;

    setMenuPosition({ top });

    setOpenMenuId(openMenuId === id ? null : id); // Toggle menu
  };

  // const handleFolderClick = (e, flodername) => {
  //    e.stopPropagation();
  //    setShowFiles(true);
  //    setFileName(flodername);
  // };

  const findPath = (tree, nodeId, path = []) => {
    if (tree.id === nodeId) {
      return [...path, tree.name];
    }
    let result = null;
    tree.items.some((item) => {
      result = findPath(item, nodeId, [...path, tree.name]);
      return result !== null; // Stop iteration if result is found
    });
    return result;
  };
  function findPathById(data, targetId) {
    const flattenAndFindPath = (items, parentPath = []) => {
      return items.flatMap(item => {
        const currentPath = [...parentPath, item.name];

        if (item.id === targetId) {
          return [currentPath];
        }

        if (item.items && item.items.length > 0) {
          return flattenAndFindPath(item.items, currentPath);
        }

        return [];
      });
    };

    const result = flattenAndFindPath(data);
    return result.length > 0 ? result[0] : null;
  }

  const handleFolderClick = (e, nodeId, flodername) => {
    e.stopPropagation();
    setShowFiles(true);
    const path = findPathById(explorerData, nodeId); // Assuming explorerData is the root tree
    let fullPath = '';
    if (path) {
      if (isSave === 'Save') {
        fullPath = path.join('/');
      } else {
        fullPath = path.map((names, index) => (
          <React.Fragment key={index}>
            {names}
            {index < path.length - 1 && <>  <img src={keyboard_arrow_right} />
            </>}
          </React.Fragment>
        ));
      }
      setFileName(fullPath);
    }
  };

  const handleMouseEnter = (id) => {
    setHoveredId(id); // Set hovered item
  };

  const handleMouseLeave = () => {
    setHoveredId(null); // Clear hovered item
  };

  if (explorer.isFolder) {
    return (
      <div
        onDrop={(e) => handleDrop(e, explorer)}
        onDragOver={handleDragOver}
        onMouseEnter={() => handleMouseEnter(explorer.id)} // Track hover
        onMouseLeave={handleMouseLeave} // Clear hover state
      >
        <div className={`folder ${clickedId === explorer.id ? 'clicked' : ''}`} onClick={toggleExpand}>
          {expand ? <VeoliaIcon
            color="#55555A"
            name="expand_more"
            size={24}
          /> : <VeoliaIcon
            color="#55555A"
            name="chevron_right"
            size={24}
          />}
          <VeoliaIcon
            color="#55555A"
            name="folder"
            filled
            size={24}
          />
          {isRenaming ? (
            <input
              autoFocus
              onKeyDown={onRename}
              onBlur={onRename}
              type="text"
              className="inputContainer__input"
              defaultValue={explorer.name}
            />
          ) : (
            <span className='text-content' title={explorer.name} onClick={(e) => handleFolderClick(e, explorer.id, explorer.name)}>
              {explorer.name}
            </span>
          )}
          {hoveredId === explorer.id && (
            <span className="more-icon" onClick={(e) => toggleMenu(e, explorer.id)}><VeoliaIcon
              color="#55555A"
              name="more_vert"
              size={24}
            /></span>
          )}
          {openMenuId === explorer.id && (
            <div className="context-menu" style={{ top: menuPosition.top }} ref={menuRef}>
              {!isRoot &&
                <div onClick={handleRename}><VeoliaIcon
                  color="#55555A"
                  name="drive_file_rename_outline"
                  size={24} />  Rename</div>
              }
              <span onClick={(e) => handleNewFolder(e, true)}><VeoliaIcon
                color="#55555A"
                name="folder"
                size={24}
              /> New Folder</span>
              {isRoot &&
                <span onClick={(e) => handleNewFolder(e, false)}><VeoliaIcon
                  color="#55555A"
                  name="insert_drive_file"
                  size={24}
                />  Add New File</span>
              }
              {!isRoot &&
                <div onClick={handleDelete}><VeoliaIcon
                  color="#55555A"
                  name="delete"
                  size={24}
                />  Delete</div>
              }
            </div>
          )}
        </div>
        <div style={{ display: expand ? 'block' : 'none', paddingLeft: 10 }}>
          {showInput.visible && (
            <div className="inputContainer">
              <span>{showInput.isFolder ? <VeoliaIcon
                color="#55555A"
                name="folder"
                size={24}
                filled
              /> : <VeoliaIcon
                color="#55555A"
                name="insert_drive_file"
                size={24}
              />}</span>
              <input
                autoFocus
                onKeyDown={onAddFolder}
                onBlur={onAddFolder}
                type="text"
                className="inputContainer__input"
              />
            </div>
          )}
          {explorer.items.map((item) => {
            return (
              <Folder
                handleInsertNode={handleInsertNode}
                handleDeleteNode={handleDeleteNode}
                handleRenameNode={handleRenameNode}
                handleMoveNode={handleMoveNode}
                setShowFiles={setShowFiles}
                setFileName={setFileName}
                explorer={item}
                explorerData={explorerData}
                key={item.id}
                isSave={isSave}  // Pass down the isSave prop
              />
            );
          })}
        </div>
      </div>
    );
  } else {
    return (
      <div
        className="file"
        draggable
        onDragStart={(e) => handleDragStart(e, explorer)}
        // onClick={(e) => handleFolderClick(e, explorer.name)}
        onMouseEnter={() => handleMouseEnter(explorer.id)} // Track hover
        onMouseLeave={handleMouseLeave} // Clear hover state
      >
        {isRenaming ? (
          <input
            autoFocus
            onKeyDown={onRename}
            onBlur={onRename}
            type="text"
            className="inputContainer__input"
            defaultValue={explorer.name}
          />
        ) : (
          <span style={{ display: 'flex', alignItems: 'center', paddingLeft: '5px' }}><VeoliaIcon
            color="#55555A"
            name="insert_drive_file"
            size={24}
          /> <span className='text-content' title={explorer.name}>{explorer.name}</span></span>
        )}
        {hoveredId === explorer.id && (
          <span className="more-icon" onClick={(e) => toggleMenu(e, explorer.id)}><VeoliaIcon
            color="#55555A"
            name="more_vert"
            size={24}
          /></span>
        )}
        {openMenuId === explorer.id && (
          <div className="context-menu" ref={menuRef}>
            <div onClick={handleRename}><VeoliaIcon
              color="#55555A"
              name="drive_file_rename_outline"
              size={24} />  Rename</div>
            <div onClick={handleDelete}><VeoliaIcon
              color="#55555A"
              name="delete"
              size={24}
            />  Delete</div>
          </div>
        )}
      </div>
    );
  }
};

export default Folder;
